import RichTextInput from "ra-input-rich-text";
import React from "react";
import {
	BooleanInput,
	required,
	SelectInput,
	SimpleForm,
	TextInput,
} from "react-admin";
import { DateTimeInput } from "../components/inputs/DatePickers";
import types from "./types";

const Form = (props) => {
	return (
		<SimpleForm {...props} redirect="list">
			<TextInput source="title" fullWidth validate={required()} />
			<TextInput source="code" fullWidth validate={required()} />
			<RichTextInput
				{...props}
				source="description"
				multline
				fullWidth
				validate={required()}
			/>
			<RichTextInput
				{...props}
				source="rules"
				multline
				fullWidth
				validate={required()}
			/>
			<DateTimeInput source="start_at" validate={[required()]} />
			<DateTimeInput source="end_at" validate={[required()]} />
			<SelectInput choices={types} source="type" validate={required()} />
			<BooleanInput source="all_bookmakers" fullWidth />
		</SimpleForm>
	);
};
export default Form;
